"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { NextIntlClientProvider } from "next-intl";
import { ArrowLeftLinear } from "solar-icon-set";
import { ErrorPageContent } from "../components/ErrorPageContent/ErrorPageContent";
import { ErrorPageWrapper } from "../components/ErrorPageWrapper/ErrorPageWrapper";
import errors from "../i18n/messages/en/errors.json";
export default function NotFound() {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      errors
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowLeftLinear size={20} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== router) {
    t2 = <NextIntlClientProvider locale="en" messages={t0}><ErrorPageWrapper><div className="flex h-full w-full items-center justify-center bg-background"><ErrorPageContent errorCode="404" action={{
            label: errors.actions.go_back_and_try_again,
            icon: t1,
            onClick: () => router.back()
          }} /></div></ErrorPageWrapper></NextIntlClientProvider>;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}